import { LocationPinOutlineIcon } from '@change/ds-icons';

import { Text } from '@change/ds-core-ui/next';

export const Location: React.FC<{ location: string | null }> = ({ location }) => {
	return (
		<div className="mr-4 flex items-center" data-testid="dm-location">
			<LocationPinOutlineIcon size={18} className="text-icon-weak mr-1 flex items-center" />
			<Text as="div" size="small" className="text-muted">
				{location}
			</Text>
		</div>
	);
};
